import React from 'react';
import { IconProps } from './types';

const Envelope: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1.1875 * size}
    height={size}
    viewBox="0 0 36 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M3.525 32h29.075c1.775 0 3.2-1.475 3.2-3.275v0-17.35c0-0.25-0.275-0.4-0.5-0.275l-16.45 10.525c-0.025 0.025-0.050 0.025-0.075 0.025-0.025 0.025-0.050 0.025-0.075 0.025-0.125 0.075-0.25 0.125-0.375 0.15-0.025 0-0.025 0-0.050 0-0.15 0.025-0.275 0.050-0.425 0.050v0c-0.15 0-0.275-0.025-0.425-0.050 0 0-0.025 0-0.050 0-0.125-0.025-0.25-0.075-0.375-0.15-0.025 0-0.050-0.025-0.075-0.025s-0.050-0.025-0.075-0.025l-16.35-10.55c-0.2-0.125-0.5 0.025-0.5 0.275 0 0 0 0 0 0v17.025c0 2 1.575 3.625 3.525 3.625z"
    />
    <path
      fill={!ignoreColor ? color : undefined}
      d="M17.8 0.025l-16.55 10.050c-0.175 0.1-0.1 0.35 0.1 0.35h33.1c0.2 0 0.275-0.25 0.1-0.35l-16.55-10.050c-0.050-0.025-0.125-0.025-0.2 0z"
    />
  </svg>
);

export default Envelope;
